import React from "react"
import Navbar from "../../components/Navbar"
import DashboardContainer from "../Dashboard/DashboardContainer"
import UserImg from "../../assets/Images/tempImg/user.png"
import Card from "../../components/Card"
import EditButton from "../../components/Buttons/EditButton"
import { InfoContainer } from "./component/InfoContainer"
import ProfileCard from "../../components/Profile/ProfileCard"
import Headings from "../../components/Texts/Headings"
const PersonalInformation = () => {
  const userDetails = {
    name: "Vikram Das",
    pan: "124VDFFFF4G",
    dob: "12/12/1990",
    gender: "Male",
    email: "vikramdas@gmail.com",
    phone: "+91 8422005522",
  }

  const { name, pan, dob, gender, email, phone } = userDetails
  return (
    <>
      <Navbar isLoggedIn={true} />
      <DashboardContainer>
        <Headings
          text="Personal Information"
        />
        <ProfileCard
          UserImg={UserImg}
          name={name}
          docTitle={"Pan Account Number"}
          doc={pan}
        />
        <Card className="mt-[18px] max-w-[100%] md:max-w-[70%]">
          <div className="flex flex-col gap-[18px] ">
            <InfoContainer title="DOB" value={dob} />
            <InfoContainer title="Gender" value={gender} />
            <InfoContainer title="Name" value={name} />
            <InfoContainer title="Email Id" value={email} />
            <InfoContainer title="Phone Number" value={phone} />
          </div>
        </Card>

      </DashboardContainer>
    </>
  )
}

export default PersonalInformation
